import ModalRoute from './ModalRoute';

export default ModalRoute;
